import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing, inlineEdit, isDateTime } from 'src/types/columnFlags';
export const getSonarFileImageSize = (version) => {
    const map = {
        'small-thumbnail': 50,
        'medium-thumbnail': 75,
        'large-thumbnail': 100,
        'small': 240,
        'medium': 460,
        'large': 800
    };
    return map[version];
};
const controlledActions = {
    create: [468],
    fetch: [469],
    update: [470],
    delete: [471],
    downloadList: [469],
    uploadList: [-1]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'id', isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'key' },
        { name: 'name', inlineEdit },
        { name: 'file_name' },
        { name: 'description', inlineEdit },
        { name: 'bucket' },
        { name: 'region' },
        { name: 'provider' },
        { name: 'tenant_id' },
        { name: 'created_at', isDateTime },
        { name: 'created_by_user_id', isInteger }
    ];
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    remoteEntityName: 'files.files',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Files'
});
export default localEntity;
